/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetThresholdViewModel {
    getFixupPrototypeFunction() { return BudgetThresholdViewModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetThresholdViewModel>): BudgetThresholdViewModel {
        let obj = Object.assign(new BudgetThresholdViewModel(), model);
        BudgetThresholdViewModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetThresholdViewModel>): BudgetThresholdViewModel {
        if (!model) return null;
        return BudgetThresholdViewModel.newInstance(<BudgetThresholdViewModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetThresholdViewModel) {
        if (!obj) return;

        models.BudgetThresholdViewModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetThresholdViewModel): boolean {
        Object.setPrototypeOf(obj, BudgetThresholdViewModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
        if (this.amount === undefined) {
            this.amount = 0;
        }
    }

    /**
     * threshold percentage
     */
    percentage: number;

    /**
     * threshold type like actual/forecasted
     */
    type: string;

    /**
     * threshold amount (0.0 if set by percentage)
     */
    amount: number;

}
